import React, { useLayoutEffect } from "react";
import { useBottomNavigator } from "utils/hooks/misc.tsx";
import { QUICK_ONBOARDING_PATH } from "common/constants.ts";
import useDrawers, { DRAWER_PATHS } from "common/Home/General/useDrawers.tsx";
import SuspenseLoading from "common/Home/General/SuspenseLoading.tsx";

const Drawers = () => {
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const { paths, drawers, visitedIndices, setVisitedIndices, currentMatch } =
    useDrawers();

  useLayoutEffect(() => {
    if (currentMatch !== undefined && !visitedIndices[currentMatch]) {
      setVisitedIndices((prevVisited) => {
        const updated = [...prevVisited];
        updated[currentMatch] = true;
        return updated;
      });
    }
    const timeout = setTimeout(() => {
      setVisitedIndices(() => {
        return Array(DRAWER_PATHS.length)
          .fill(false)
          .map((_, index) => index === currentMatch);
      });
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [currentMatch]);

  return (
    <SuspenseLoading>
      {visitedIndices.map((shouldRender, index) => {
        const path = paths[index];
        if (
          shouldRender &&
          (path !== QUICK_ONBOARDING_PATH || !isBottomNavigator)
        ) {
          return drawers[index];
        }
        return null;
      })}
    </SuspenseLoading>
  );
};

export default Drawers;
